import React from "react";
import {
  Box,
  Card,
  CardContent,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ComingSoonWrapper from "@ui-library/ComingSoon";
import Text, { Body } from "./Text";
import Tag from "./Tag";

const Frame = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "16px 16px 32px 24px",
  alignItems: "flex-start",
  border: "1px solid rgba(0, 0, 0, 0.10);",
  borderRadius: 12,
  boxShadow: "none",
  backgroundColor: theme.vars.palette.base.primary,
  gap: 8,
  minWidth: 400,
}));

const Header = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  alignSelf: "stretch",
  padding: 0,
  minHeight: 25,
});

const Container = styled(CardContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  padding: 0,
  ":last-child": { paddingBottom: 0 },
});

const Grid = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
});

const Content = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: "1 0 0",
  gap: "24px",
});

const PromotionCard = ({ children, ...props}) => {
  const {
    left,
    right,
    title,
    body,
    button,
    tag,
    isHoverable = false,
    isComingSoon = false,
    sx = {},
    ...rest
  } = props;
  const textProps = { title, body };
  const theme = useTheme();
  const isLessThan424px = useMediaQuery("(max-width: 424px");

  const card = (
    <Frame
      {...rest}
      sx={{
        ...sx,
        ...(isHoverable && { ...theme.hoverable }),
        ...(isLessThan424px && { minWidth: "100%" }),
      }}
    >
      <Header>{tag && <Tag tag={tag} />}</Header>
      <Container>
        <Grid>
          {left && <Grid sx={{ width: "80px" }}>{left}</Grid>}
          <Content>
            <Text {...textProps} />
            {button}
            <Body body={children} />
          </Content>
          {right && <Grid>{right}</Grid>}
        </Grid>
      </Container>
    </Frame>
  );

  return (
    isComingSoon
      ? <ComingSoonWrapper sx={{
          ...(isLessThan424px && { minWidth: "100%" })
        }}>
          {card}
        </ComingSoonWrapper>
      : card
  );
};

export default PromotionCard;
